// src/store/slices/inquirySlice.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import { createGenericSlice } from './genericSliceFactory';
import { apiMethods } from '../../services/api';
import type { Inquiry, InquiryStatus, ApiResponse } from '@/types';

const inquirySlice = createGenericSlice<Inquiry>({
    name: 'inquiries',
    endpoint: '/inquiries',
});

export const {
    setCurrentItem: setCurrentInquiry,
    clearError,
    setSelectedIds,
    toggleSelectId,
    clearSelectedIds,
} = inquirySlice.actions;

export const {
    create: createInquiry,
} = inquirySlice.thunks;


export default inquirySlice.reducer;